import React, { FC, useCallback } from 'react';

import { Avatar, Button, Pecten, Popover, Sizes } from '@sede-enterprise/shell-ds-react-framework';

import { useDispatch, useSelector } from 'react-redux';

import { themeActions } from 'src/store/Theme';
import { IFullState } from 'src/types/All.type';
import UserOptions from 'src/components/Auth/UserOptions';
import IconExport from '../../Icons/IconExport';
import IsDarkTheme from '../hooks/IsDarkTheme';
import { HeaderSection } from './index.style';

const UserDropdown: FC<{ children: React.ReactElement }> = ({ children }) => {
  return (
    <Popover popup={<UserOptions />} popupPlacement='bottomRight' action='click' arrow>
      <div>{children}</div>
    </Popover>
  );
};

const Header: FC = () => {
  const isDark = IsDarkTheme();
  const dispatch = useDispatch();
  const userDetails = useSelector((state: IFullState) => state.genesisUserRolePermission);

  const handleThemeOnChange = useCallback(
    (value: boolean) => {
      dispatch(themeActions.updateTheme({ isDark: value }));
    },
    [dispatch],
  );

  const shortName = `${userDetails.userName.split(' ')[0][0]}${
    userDetails.userName.split(' ').slice(-1)[0][0]
  }`;

  return (
    <HeaderSection>
      <div className='header-section'>
        <div className='logo'>
          <Pecten size='medium' />
          <div className='header-title'>
            <span className='header-title-up'>Shell Energy</span>
            <span className='header-title-down'>Genesis</span>
          </div>
        </div>
        <div className='user'>
          <Button
            size='large'
            variant='transparent'
            iconOnly
            onClick={() => handleThemeOnChange(!isDark)}
            icon={isDark ? <IconExport.SunSolid /> : <IconExport.MoonSolid />}
            className='theme-switcher'
          />

          <UserDropdown>
            <Avatar
              size={Sizes.Medium}
              abbreviation={shortName}
              label={userDetails.userName}
              secondaryLabel={userDetails.mail}
              aria-label={userDetails.userName}
            />
          </UserDropdown>
        </div>
      </div>
    </HeaderSection>
  );
};
export default Header;
